import Link from 'next/link'

import Fade from 'react-reveal/Fade'

import SEO from 'src/components/SEO'

import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function Csv({ headUrl, headTitle, headDesc }) {
  return (
    <div>
      <SEO url={headUrl} title={headTitle} desc={headDesc} />
      <div className='w-full h-full font-normal'>
        <div className='page-content py-40'>
          {/* <Link href='/about/csv/manual' className='text-right'>
            <button type='button' className='btn glass_in_btn text-base'>
              사용 매뉴얼
            </button>
          </Link> */}

          <Fade bottom cascade>
            <div className='md:flex md:justify-center md:items-center mt-12 mb-28 rounded-visitor-market aiso_glass_in_bg'>
              <div className='w-full md:w-1/2 p-5'>
                <div className='img-cover-box'>
                  <img src='/images/visitor/dev_02.png' alt='' />
                </div>
              </div>
              <div className='w-full md:w-1/2 p-5 keep-words'>
                <h2 className='text-2xl text-333 pt-0 pb-4 font-bold md:text-4xl md:text-left lg:pt-28'>
                  데이터 파일로 분석 앱을 제작해 보세요!
                </h2>
                <span className='block text-555 mb-2 text-sm lg:text-base'>
                  분석을 원하는 데이터 파일만으로 서비스 앱 제작이 가능합니다!
                </span>
                <span className='block text-555 pb-5 text-sm lg:text-base'>
                  나의 분석된 데이터를 앱으로 제작하여 거래해 보세요!
                </span>
              </div>
            </div>
          </Fade>
        </div>
      </div>

      {/* 데이터 분석 사용법 */}
      <div className='w-full h-full bg-white'>
        <div className='page-content py-20'>
          <Fade bottom cascade>
            <div className='keep-words mo-text'>
              <h3 className='text-base text-555 font-bold pt-28 pb-4 md:text-2xl'>
                <i className='fa fa-question-circle mr-3 text-blue-400' />
                데이터 분석으로 인공지능 서비스를 어떻게 사용하나요?
              </h3>
              <h1 className='text-xl text-333 pb-5 font-bold md:text-3xl'>데이터 분석 이용 방법 (CSV)</h1>
            </div>
          </Fade>
          <Fade bottom cascade>
            <div className='md:flex md:justify-center md:items-center rounded-visitor-market my-14'>
              <div className='w-full md:w-1/2'>
                <div className='img-cover-box'>
                  <img src='/images/csv/main_01.png' alt='' />
                </div>
              </div>
              <div className='w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words'>
                <h1 className='text-2xl text-gray-300 font-bold tracking-widest pb-4 sm:pb-5 text-4xl'>01</h1>
                <p className='text-xl text-333 font-bold pb-3 md:text-2xl'>나의 CSV 데이터 파일 업로드</p>
                <p className='text-base text-555 md:text-lg'>내가 분석할 CSV 데이터 파일을 업로드합니다.</p>
              </div>
            </div>
          </Fade>
          <div className='text-center text-4xl text-gray-300 py-5'>
            <i className='fa fa-arrow-circle-down'></i>
          </div>
          <Fade bottom cascade>
            <div className='md:flex md:justify-center md:items-center rounded-visitor-market my-14'>
              <div className='w-full md:w-1/2'>
                <div className='img-cover-box'>
                  <img src='/images/csv/main_02.png' alt='' />
                </div>
              </div>
              <div className='w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words'>
                <h1 className='text-2xl text-gray-300 font-bold tracking-widest pb-4 sm:pb-5 text-4xl'>02</h1>
                <p className='text-xl text-333 font-bold pb-3 md:text-2xl'>데이터 분석 진행 과정 실시간 확인</p>
                <p className='text-base text-555 md:text-lg'>
                  CSV 데이터의 분석 과정이 실시간으로 표시됩니다. <br />
                  분석이 완료된 데이터는 나의 히스토리 메뉴에서 언제든 확인할 수 있습니다.
                </p>
              </div>
            </div>
          </Fade>
          <div className='text-center text-4xl text-gray-300 py-5'>
            <i className='fa fa-arrow-circle-down' />
          </div>
          <Fade bottom cascade>
            <div className='my-14'>
              <div className='w-full'>
                <div className='w-full mb-32'>
                  <div className='md:flex md:justify-center md:items-center rounded-visitor-market'>
                    <div className='w-full md:w-1/2'>
                      <div className='img-cover-box'>
                        <img src='/images/csv/main_03.png' alt='' />
                      </div>
                    </div>
                    <div className='w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words'>
                      <h1 className='text-2xl text-gray-300 font-bold tracking-widest pb-4 sm:pb-5 text-4xl'>03</h1>
                      <p className='text-xl text-333 font-bold pb-3 md:text-2xl'>데이터 미리보기</p>
                      <p className='text-base text-555 md:text-lg'>
                        분석된 데이터를 그리드 형태로 미리 확인할 수 있습니다.
                      </p>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <div className='md:flex md:justify-center md:items-center rounded-visitor-market'>
                    <div className='w-full md:w-1/2'>
                      <div className='img-cover-box'>
                        <img src='/images/csv/main_04.png' alt='' />
                      </div>
                    </div>
                    <div className='w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words'>
                      <p className='text-xl text-333 font-bold pb-3 md:text-2xl'>데이터 특징</p>
                      <p className='text-base text-555 md:text-lg'>
                        사용된 데이터에 대한 상세 정보와 컬럼별 특징에 대한 상세 정보를 알 수 있습니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='w-full'>
                <div className='w-full mb-32'>
                  <div className='md:flex md:justify-center md:items-center rounded-visitor-market'>
                    <div className='w-full md:w-1/2'>
                      <div className='img-cover-box'>
                        <img src='/images/csv/main_05.png' alt='' />
                      </div>
                    </div>
                    <div className='w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words'>
                      <p className='text-xl text-333 font-bold pb-3 md:text-2xl'>히트맵 & 산점도</p>
                      <p className='text-base text-555 md:text-lg'>
                        분석된 데이터를 히트맵 및 산점도로 확인할 수 있습니다.
                      </p>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <div className='md:flex md:justify-center md:items-center rounded-visitor-market'>
                    <div className='w-full md:w-1/2'>
                      <div className='img-cover-box'>
                        <img src='/images/csv/main_06.png' alt='' />
                      </div>
                    </div>
                    <div className='w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words'>
                      <p className='text-xl text-333 font-bold pb-3 md:text-2xl'>인공지능 학습</p>
                      <p className='text-base text-555 md:text-lg'>
                        학습 유형, 사용된 알고리즘, 타겟, 학습에 영향을 준 특징들, 정확도를 알 수 있으며 선택한 타겟의
                        결과를 알 수 있습니다.
                      </p>
                    </div>
                  </div>
                </div>
                <div className='w-full'>
                  <div className='md:flex md:justify-center md:items-center rounded-visitor-market'>
                    <div className='w-full md:w-1/2'>
                      <div className='img-cover-box'>
                        <img src='/images/csv/main_07.png' alt='' />
                      </div>
                    </div>
                    <div className='w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words'>
                      <p className='text-xl text-333 font-bold pb-3 md:text-2xl'>시계열 데이터</p>
                      <p className='text-base text-555 md:text-lg'>
                        데이터에 날짜 항목이 있는 경우, 자동으로 시계열 분석을 진행합니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>

      {/* 데이터 분석 설명 */}
      {/* <div className='w-full h-full bg-gray-input'>
        <div className='page-content pt-20 pb-60'>
          <Fade bottom cascade>
            <div className='keep-words'>
              <div>
                <h3 className='text-888 font-bold pt-28 pb-4'>
                  <i className='fa fa-question-circle mr-3 text-primary' />
                  데이터 분석 앱은 어떻게 제작하나요?
                </h3>
                <h1 className='text-333  pb-1'>데이터 분석 앱 제작 방법 </h1>
                <p className='text-333 pb-5 text-xl'>CSV 파일 데이터 분석</p>
              </div>
            </div>
          </Fade>
          <Fade bottom cascade>
            <div className='md:flex md:justify-center md:items-center rounded-visitor-market mb-5'>
              <div className='w-full md:w-1/2'>
                <div className='img-cover-box'>
                  <img src='/images/visitor/data_make-1.png' alt='' />
                </div>
              </div>
              <div className='w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words'>
                <h1 className='text-gray-300  tracking-widest pb-4 sm:pb-5'>01</h1>
                <p className='text-333 text-2xl font-bold pb-3'>나의 데이터 분석 목록</p>
                <p className='text-555 text-lg'>
                  데이터 분석 목록 중 앱으로 제작하고 싶은 분석 데이터를 선택하여 제작하거나 새로운 데이터를 추가하여
                  분석합니다.
                </p>
              </div>
            </div>
          </Fade>
          <div className='center text-4xl text-gray-300 py-5'>
            <i className='fa fa-arrow-circle-down'></i>
          </div>
          <Fade bottom cascade>
            <div className='md:flex md:justify-center md:items-center rounded-visitor-market mb-5'>
              <div className='w-full md:w-1/2'>
                <div className='img-cover-box'>
                  <img src='/images/visitor/data_make-2.png' alt='' />
                </div>
              </div>
              <div className='w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words'>
                <h1 className='text-gray-300  tracking-widest pb-4 sm:pb-5'>02</h1>
                <p className='text-333 text-2xl font-bold pb-3'>데이터 파일을 업로드</p>
                <p className='text-555 text-lg'>
                  분석할 데이터 파일(csv)을 업로드 한 후 타겟을 설정합니다. 데이터 파일이 없을 시 아래 샘플 데이터
                  파일을 사용해 보세요.
                </p>
              </div>
            </div>
          </Fade>
          <div className='center text-4xl text-gray-300 py-5'>
            <i className='fa fa-arrow-circle-down'></i>
          </div>
          <Fade bottom cascade>
            <div className='mt-14 mb-32'>
              <div className='w-full'>
                <div className='md:flex md:justify-center md:items-center rounded-visitor-market'>
                  <div className='w-full md:w-1/2'>
                    <div className='img-cover-box'>
                      <img src='/images/visitor/data_make-3-1.png' alt='' />
                    </div>
                  </div>
                  <div className='w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words'>
                    <h1 className='text-gray-300  tracking-widest pb-4 sm:pb-5'>
                      03-<span className='text-4xl'>1</span>
                    </h1>
                    <p className='text-333 text-2xl font-bold pb-3'>
                      나의 데이터 분석 결과 확인 <br />: 데이터 분석
                    </p>
                    <p className='text-555 text-lg'>
                      나의 분석된 데이터 결과를 확인하고 앱을 제작합니다.
                    </p>
                  </div>
                </div>
              </div>
              <div className='w-full'>
                <div className='md:flex md:justify-center md:items-center rounded-visitor-market'>
                  <div className='w-full md:w-1/2'>
                    <div className='img-cover-box'>
                      <img src='/images/visitor/data_make-3-2.png' alt='' />
                    </div>
                  </div>
                  <div className='w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words'>
                    <h1 className='text-gray-300  tracking-widest pb-4 sm:pb-5'>
                      03-<span className='text-4xl'>2</span>
                    </h1>
                    <p className='text-333 text-2xl font-bold pb-3'>
                      나의 데이터 분석 결과 확인
                      <br />: 알고리즘
                    </p>
                    <p className='text-555 text-lg'>
                      분석된 데이터의 알고리즘을 확인하고 앱을 제작합니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Fade>
          <div className='center text-4xl text-gray-300 py-5'>
            <i className='fa fa-arrow-circle-down'></i>
          </div>
          <Fade bottom cascade>
            <div className='md:flex md:justify-center md:items-center rounded-visitor-market my-14'>
              <div className='w-full md:w-1/2'>
                <div className='img-cover-box'>
                  <img src='/images/visitor/data_make-4.png' alt='' />
                </div>
              </div>
              <div className='w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words'>
                <h1 className='text-gray-300  tracking-widest pb-4 sm:pb-5'>04</h1>
                <p className='text-333 text-2xl font-bold pb-3'>
                  데이터 분석 앱 제작 <br />: 컬럼 설명
                </p>
                <p className='text-555 text-lg'>
                  각 컬럼에 대한 설명을 작성합니다. 다음 제작 단계는 서비스 앱 제작과 동일하며 같은 방법으로 작성합니다.
                </p>
              </div>
            </div>
          </Fade>
          <div className='center text-4xl text-gray-300 py-5'>
            <i className='fa fa-arrow-circle-down'></i>
          </div>

          <Fade bottom cascade>
            <div className='md:flex md:justify-center md:items-center rounded-visitor-market my-14'>
              <div className='w-full md:w-1/2'>
                <div className='img-cover-box'>
                  <img src='/images/visitor/data_make-5.png' alt='' />
                </div>
              </div>
              <div className='w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-32 keep-words'>
                <h1 className='text-gray-300  tracking-widest pb-4 sm:pb-5'>05</h1>
                <p className='text-333 text-2xl font-bold pb-3'>
                  나의 데이터 분석 앱을 데이터 분석에 등록하여 거래해 보세요!
                </p>
              </div>
            </div>
          </Fade>
        </div>
      </div> */}

      <div className='px-10 py-20 keep-words text-center'>
        <h1 className='text-xl text-slate-800 font-bold pb-3 md:text-3xl'>
          나의 인공지능 서비스 앱을 제작하여 수익을 창출해 보세요!
        </h1>
        <p className='text-333 text-sm mb-4 md:text-lg'>
          내가 찾던 인공지능 서비스와 유사한 서비스를 제작한 개발자에게 의뢰를 문의해 보세요.
        </p>

        <Link href='https://aisodata2-proj.web.app/service/analysis' target='_blank'>
          <button
            type='button'
            className='text-slate-700 text-center bg-white rounded-full text-sm p-3 shadow-md ease-in-out transition-transform hover:opacity-70'
          >
            데이터 분석하기
            <FontAwesomeIcon icon={faUpRightFromSquare} className='ml-2 text-slate-700' size='sm' />
          </button>
        </Link>
      </div>
    </div>
  )
}

export async function getStaticProps() {
  let headTitle = 'AISO CSV'
  let headDesc = 'CSV 데이터 분석 솔루션'
  const headUrl = `https://aisodata.co.kr/about/csv`

  return { props: { headUrl, headTitle, headDesc } }
}
